<template>
  <div class="place-order">
    <header-com/>
    <order-header :title="'一键下单'" @choseAdr='choseAdr' :model='adrList'/>
    <div class='line_bg'>

    </div>
    <div class="list">
      <li>
        <div class="left mydiv">
          <img src="/images/public/icon-num.png" alt="" />
          <span>养护数量</span>
        </div>
        <div class="right rightPicker mydiv" style='width:100px' @click='show = true' :class="{colorGrey:defaultIndex == '请选择'}">
           {{defaultIndex=='请选择'?defaultIndex:defaultIndex + '件'}}
        </div>
      </li>
      <li  style='border:none;margin-top:10px'>
        <van-field
            @blur="inputBlur"
            v-model="remark"
            type="textarea"
            placeholder="还有什么要交待的？这里留言"
            rows="5"
            :clearable="true"
            autosize
          />
      </li>
    </div>
    <div class="g-fixed-bottom toolbar">
      <div class='right_cont'>
        <!-- <img src="/images/public/bag_del.png" alt="" class='del_img' @click='clearBag'/> -->
        <button class="primary" @click='submitCart'>立即预约</button>
      </div>

    </div>
    <!-- 选择地址 -->
    <van-popup position="bottom" v-model="adrShow">
      <div class="containerAdr f28">
        <div class="title">选择地址</div>
        <!-- <span @click="$router.push({ name: 'addressEdit'})">添加地址</span> -->
        <div class="close" @click="adrShow = false"></div>
        <div class="addr-container">
          <ul>
            <li v-for='(item,index) in adrList' :key='index' @click='adrClick(index)'>
              <div class='li_div'>
                 <radio :checked='item.isDefault'/>
              </div>
              <addr-com :model='item' :selected='item.trueDefault'/>
            </li>
          </ul>
        </div>
        <button class="primary fl" @click="$router.push({ name: 'addressEdit'})">添加地址</button>
      </div>
    </van-popup>

    <van-popup v-model="show" position="bottom" :overlay="true" >
      <van-picker :columns="columns" 
        show-toolbar
        @cancel="show = false"
        :default-index="defaultIndex"
        @confirm="onConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
  import homeApi from '@/axios/home'
  import myApi from '@/axios/my'
  import { Toast , Dialog} from 'vant';
  import zhugeObj from '@/assets/js/track'
  import publicObj from '@/assets/js/public'
  export default {
    name: 'index',
    data () {
      return {
        show : false,
        bagQuantity : '',
        defaultIndex:'请选择',
        adrList : [],
        remark : '',
        adrShow: false,
        columns : [],
        num: 0,
        enterComfirm : false,
        detail : {
          curingServiceList : []
        },
      }
    },
    computed: {
      defaultImg () {
        return this.DEFAULT_IMG
      },
    },
    created(){
      this.getAdressList();
      for(let i=1;i<=50;i++){
        this.columns.push(i);
      }
    },
    methods : {
      inputBlur(){
        publicObj.IPhoneXHack()
      },
      onConfirm(value, index){
        this.defaultIndex = value;
        this.show = false;
        if(this.enterComfirm){
          this.submitCart();
        }
      },
      changeRadio(index){
        this.detail.curingServiceList[index].checkRadio = !this.detail.curingServiceList[index].checkRadio;
      },
      formatImgUrl(url, width, height,m_fill) {
        // console.log(url)
        if (url) {
          url = url.replace('h_{height},w_{width}', "h_" + height + ",w_" + width + "");
          // url = url.replace(',jpg', ",webp");
          url +=',q_80';
          if(m_fill){
            // console.log(m_fill)
            url = url.replace('m_lfit', "m_fill");
          }
        }
        return url
      },
      clearBag(){
        Dialog.confirm({
          title: '',
          message: '您确认清空购物车?'
        }).then(() => {
          homeApi.clearBag().then((res)=>{
            this.getAdressList();
          })
        }).catch(() => {
          // on cancel
        });
      },
      submitCart(){
        if(this.defaultIndex == '请选择'){
          Toast('请您选择物品数量');
          this.show = true;
          this.enterComfirm = true;
          return;
        };
        let params = {
          remarks : this.remark,
          bagQuantity : this.defaultIndex,
          pickingWay: 10,
          action : 'direct'
        };

        
        //获得地址ID
        this.adrList.forEach((element)=>{
          if(element.isDefault){
            params.addressId= element.id;
          }
        })
        homeApi.submitCart(params).then((res)=>{
          this.$router.replace({name:'orderList',params:{type:1}})
         
        }).catch(()=>{
         
        })
      },
      choseAdr(){
        if(this.adrList.length == 0){
          this.$router.push({ name: 'addressEdit'})
        }else{
          this.adrShow = true;
        }
      },
      getAdressList(){
        myApi.customerAddress({}).then((res)=>{
          let defaultNum = 0;
          let index = 0;
          let mostTime = '1970-01-01'
          res.forEach((element,index)=>{
            element.trueDefault = element.isDefault;
            if(element.isDefault){
              defaultNum++;
            }
            let mostDate = new Date(mostTime).getTime();
            let elementDate = new Date(element.updateTime).getTime();
            if(elementDate>mostDate){
              mostTime = element.updateTime;
              index = index;
            }
          })

          if(defaultNum == 0){
            res[index].isDefault = true;
          }
          this.adrList = res;

          this.getShoppingCart();
        })
      },
      adrClick(index){
        
        this.adrList.forEach((element,idx) => {
            if(index == idx){
              element.isDefault = true;
            }else{
              element.isDefault = false;
            }
        });
        this.adrShow = false;
        //todo判断地址是否可以包邮
        this.getShoppingCart();

      },
      freePostage(areacode){
        
      },
      getShoppingCart(){
        let adrId;
        this.adrList.forEach((item)=>{
          if(item.isDefault){
            adrId = item.id;
          }
        })
        let params = {
          action : 'direct',
          addressId : adrId
        }
        homeApi.getShoppingCart(params).then((res)=>{
          this.detail =  res;
        })
      },

    }
  }
</script>

<style scoped lang="scss">
.mydiv{
    display: flex;
    align-items: center;
    font-size:28px;
}
.fl{
  float: right;
  margin-top: 30px;
}
.li_div{
  display: flex;
  height: 100%;
}
.rightPicker{
  text-align: right;
  justify-content: flex-end;
  background:  url("/images/public/grey_row.png") no-repeat right;
  background-size:12px; 
  padding-right: 25px;
}
.picker{
  width: 400px;
  height: 40px;
}
.radio_top{
  margin-top: 68px;
}
.line_bg{
  width: 100%;
  height: 16px;
  background: #f8f8f8;
}
.border_b{
   border-bottom:1px solid #EEEEEE;
}
.left_cont{
  font-size:26px!important; 
  color:#333333!important;
  span{
    font-size:40px; 
    margin-left: 5px;
    position: relative;
    top:-3px;
    font-weight:500; 
  }
}
.right_cont{
  margin-right: 0!important;
}
.del_img{
  width: 38px;
  margin-right: 36px!important;
}
.g-fixed-bottom{
  padding-top: 0;
}
.number_name{
  font-weight: 500;
  span{
    font-weight: 400;
    font-size: 24px;
    color:#aab2bd;
  }
}
.name_content{
  display: flex;
  justify-content: space-between;
  line-height: 40px;
}
.f24{
  font-size: 24px;
}
.oneClamp{
  font-size:28px;

}
.colorGrey{
  color: #ccc;
}
 input::-webkit-input-placeholder {
      /* placeholder颜色  */
    color: #ccc;
      /* placeholder字体大小  */
      font-size: 28px;
      /* placeholder位置  */
      text-align: right;
  }
  .no_content{
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .no-list{
    width:100%;
    margin-top: 0px;
  }
  .remark{
    text-align: right;
  }
  .place-order{
    padding-bottom:120px;
    .goods{
      padding: 40px 30px 60px;
      padding-bottom:0; 
      padding-top: 0;
      li{
        display: flex;
        position: relative;
        margin-top:40px;
        // margin-bottom: 40px; 
        padding-bottom: 40px;
        .select{
          width: 32px;
          flex: none;
          margin-right: 16px;
          // display: flex;
          // align-items: center;
        }
        .img{
          width: 160px;
          height: 160px;
          flex: none;
          overflow: hidden;
          border: 1px solid #eee;
          border-radius:6px; 
          img{
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
        .info{
          flex: auto;
          margin-left: 20px;
          .name{
            width: 336px;
            line-height: 40px;
            font-weight: 500;
          }
          .category{
            line-height: 34px;
            margin-top: 6px;
          }
          .tool-bar{
            width: 100%;
            margin-top: 58px;
            display: inline-flex;
            justify-content: space-between;
            .total-amount{
              font-weight: 500;
              line-height: 53px;
            }
          }
        }
      }
    }
    .list{
      padding: 0 30px;
      // margin-top: 58px;
      li{
        width: 100%;
        height: 104px;
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #eee;
        &>div{

          img{
            width: 40px;
            height: 40px;
            object-fit: cover;
            margin-right: 22px;
          }
          input{
            height: 104px;
            border: none;
            font-size:28px;
            &.remark{
              width: 500px;
            }
            &.num{
              text-align: right;
            }
            &::placeholder{
              text-align: right;
            }
          }
        }
      }
    }
    .toolbar{
      display: flex;
      flex-direction: row-reverse;
      align-items: center;
      justify-content: space-between;
      &>div{
        color: $theme-color;
        display: flex;
        align-items: center;
        margin-right: 44px;
        img{
          width: 38px;
          height: 44px;
          object-fit: cover;
          margin-right: 14px;
        }
      }
    }
  }


  .containerAdr{
    height: 860px;
    padding: 32px;
    position: relative;
    padding-bottom:60px;
    padding-top: 0px;
    .title{
      line-height: 90px;
      border-bottom:1px solid #EEEEEE;
      font-size: 28px;
      font-weight:500; 
    }
    &>span{
      position:absolute;
      right:30px;
      top:80px;
      color:#7ADFDF;
    }
    .addr-container{
      height: 700px;
      overflow-y: scroll;
      ul li{
        width: 100%;
        display: flex;
        padding-top:32px;

        // align-items: center;
      }
    }
    .close{
      width: 36px;
      height: 36px;
      position: absolute;
      top: 30px;
      right: 30px;
      background: url("/images/public/close.png") no-repeat center;
      background-size: 32px;
    }
    .submit{
      position: absolute;
      bottom: 30px;
      right: 30px;
    }
  }
</style>
